<div fxFlex fxLayout="column" fxFlexFill>
    <div fxFlex>
        <mat-toolbar color="primary">
            <mat-toolbar-row>
                <div fxShow="true" fxHide.lt-md fxFlex fxLayout>
                    <div fxFlex>
                        <span class="mat-h3">{{ "STATISTICPILOTHOURS.pageTitle" | translate }}</span>
                    </div>
                </div>
            </mat-toolbar-row>
        </mat-toolbar>
    </div>
    <div fxFlex class="p-10">
        <div fxFlex fxLayout="column" fxLayoutAlign="start stretch" fxFlexFill>
            <mat-card appearance="outlined" fxFlex>
                <mat-card-content>
                    <form #filterForm="ngForm" [formGroup]="statisticFilterForm">
                        <div fxFlex fxLayout="row" fxLayoutAlign="start stretch" fxFlexFill fxLayoutGap="20px">
                            <mat-form-field fxFlex="15" [floatLabel]="'always'">
                                <mat-label>{{ "STATISTICPILOTHOURS.currentDate" | translate }}</mat-label>
                                <input
                                    matInput
                                    [matDatepicker]="currentDateDatePicker"
                                    [placeholder]="'STATISTICPILOTHOURS.currentDate' | translate"
                                    name="currentDate"
                                    formControlName="currentDate"
                                    (dateChange)="updateCalcs($event)"
                                />
                                <mat-datepicker-toggle matSuffix [for]="currentDateDatePicker"></mat-datepicker-toggle>
                                <mat-datepicker #currentDateDatePicker></mat-datepicker>
                                @if (statisticFilterForm.controls["currentDate"].hasError("matDatepickerParse")) {
                                    <mat-error>{{ "GENERAL.invalidDateFormat" | translate }}</mat-error>
                                }
                                @if (statisticFilterForm.controls["currentDate"].hasError("required")) {
                                    <mat-error>{{ "GENERAL.required" | translate }}</mat-error>
                                }
                            </mat-form-field>
                        </div>
                    </form>
                </mat-card-content>
            </mat-card>
            <div fxFlex class="mt-20">
                <table #flightsTable mat-table [dataSource]="dataTable" class="mat-elevation-z8" style="width: 100%">
                    <!-- Position Column -->
                    <ng-container matColumnDef="pilotName">
                        <th mat-header-cell *matHeaderCellDef>
                            {{ "STATISTICPILOTHOURS.pilotName" | translate }}
                        </th>
                        <td mat-cell *matCellDef="let element" style="padding-left: 24px !important">
                            {{ element.pilotName }}
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="prev28Days">
                        <th mat-header-cell *matHeaderCellDef class="data-cell">
                            {{ addDays(currentDate, -27, "DD/MM/YYYY") }} -
                            {{ addDays(currentDate, 0, "DD/MM/YYYY") }}
                            {{ "STATISTICPILOTHOURS.prev28Days" | translate }}
                        </th>
                        <td mat-cell *matCellDef="let element" class="data-cell">
                            <div class="trend-row">
                                <div class="progress-bar row">
                                    <div
                                        class="inner done"
                                        [style]="'width:' + element.prev28Days.done.percent + '%'"
                                        [matTooltip]="element.prev28Days.done.val"
                                        [matTooltipPosition]="position.value"
                                        matTooltipHideDelay="10"
                                    ></div>
                                    <div
                                        class="inner todo"
                                        [style]="'width:' + element.prev28Days.todo.percent + '%'"
                                        [matTooltip]="element.prev28Days.todo.val"
                                        [matTooltipPosition]="position.value"
                                        matTooltipHideDelay="10"
                                    ></div>
                                </div>
                                <span style="font-size: 13px">
                                    {{ getLabel(element.prev28Days.done.val, element.prev28Days.todo.val, element.prev28Days.remaining.val) }}
                                </span>
                            </div>
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="prev7Days">
                        <th mat-header-cell *matHeaderCellDef class="data-cell">
                            {{ addDays(currentDate, -6, "DD/MM/YYYY") }} -
                            {{ addDays(currentDate, 0, "DD/MM/YYYY") }}
                            {{ "STATISTICPILOTHOURS.prev7Days" | translate }}
                        </th>
                        <td mat-cell *matCellDef="let element" class="data-cell">
                            <div class="trend-row">
                                <div class="progress-bar row">
                                    <div
                                        class="inner done"
                                        [style]="'width:' + element.prev7Days.done.percent + '%'"
                                        [matTooltip]="element.prev7Days.done.val"
                                        [matTooltipPosition]="position.value"
                                        matTooltipHideDelay="10"
                                    ></div>
                                    <div
                                        class="inner todo"
                                        [style]="'width:' + element.prev7Days.todo.percent + '%'"
                                        [matTooltip]="element.prev7Days.todo.val"
                                        [matTooltipPosition]="position.value"
                                        matTooltipHideDelay="10"
                                    ></div>
                                </div>
                                <span style="font-size: 13px">
                                    {{ getLabel(element.prev7Days.done.val, element.prev7Days.todo.val, element.prev7Days.remaining.val) }}
                                </span>
                            </div>
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="selectedDate">
                        <th mat-header-cell *matHeaderCellDef class="data-cell">
                            {{ currentDate }}
                        </th>
                        <td mat-cell *matCellDef="let element" class="data-cell">
                            <div class="trend-row">
                                <div class="progress-bar row">
                                    <div
                                        class="inner done"
                                        [style]="'width:' + element.selectedDate.done.percent + '%'"
                                        [matTooltip]="element.selectedDate.done.val"
                                        [matTooltipPosition]="position.value"
                                        matTooltipHideDelay="10"
                                    ></div>
                                    <div
                                        class="inner todo"
                                        [style]="'width:' + element.selectedDate.todo.percent + '%'"
                                        [matTooltip]="element.selectedDate.todo.val"
                                        [matTooltipPosition]="position.value"
                                        matTooltipHideDelay="10"
                                    ></div>
                                </div>
                                <span style="font-size: 13px">
                                    {{ getLabel(element.selectedDate.done.val, element.selectedDate.todo.val, element.selectedDate.remaining.val) }}
                                </span>
                            </div>
                        </td>
                    </ng-container>
                    <!--  -->
                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
                    <!-- <tr mat-footer-row *matFooterRowDef="displayedColumns" class="example-first-footer-row"></tr> -->
                </table>
            </div>
        </div>
    </div>
</div>
